export default "__VITE_ASSET__RudNhjHV__"